import {
  Box,
  Backdrop,
  CircularProgress,
  Typography,
  useTheme,
} from "@mui/material"
import { MotionDiv, loadingScreen, logoMotionVariants } from "../motions"
import { Image } from "components/Image"
import { useTranslation } from "providers/i18n"
import { useMemo } from "react"
import { get } from "lodash"

export const MapUpdatingScreen = (props) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { backdrop, container } =
    theme.components?.["MapUpdateLoadingScreen"].styleOverrides || {}

  if (!props.open) return null

  return (
    <Backdrop {...props} sx={backdrop}>
      <Box sx={container}>
        <CircularProgress />
        <Typography>{t("Updating Map")}</Typography>
      </Box>
    </Backdrop>
  )
}

export const LoadingScreen = (props) => {
  const theme = useTheme()
  const logo = theme.assets?.loadingLogo || theme.assets?.logo
  const styleOverrides = theme.components[`LoadingScreen`]?.styleOverrides || {}
  const { logoMotionVariant } =
    theme.components[`LoadingScreen`]?.defaultProps || {}
  const { root, logo: logoStyle, backgroundLoading } = styleOverrides
  const logoAnimation = useMemo(() => {
    return (
      get(logoMotionVariants, logoMotionVariant) ||
      get(logoMotionVariants, "pulseAndFade")
    )
  }, [logoMotionVariant])
  return (
    <MotionDiv
      variants={loadingScreen}
      initial="initial"
      animate="enter"
      exit="exit"
      sx={root}
      {...props}
    >
      <MotionDiv key="logo" variants={logoAnimation} animate="animate">
        {logo && <Image src={logo.url} alt="Logo" sx={logoStyle} />}
      </MotionDiv>
      <Box sx={backgroundLoading}></Box>
    </MotionDiv>
  )
}
